import Vue from 'vue'
import App from './App'
import router from './router'
import "lib-flexible";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 适配
import 'amfe-flexible';
import 'amfe-flexible/index.js';
// 引入iconfont
import '../iconfont.css'
// 动画 animate.css
import animate from "animate.css";
Vue.use(animate)


import axios from 'axios'
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = 'https://api.back.market.muyouhuo.com/xinfuhuixuan-back/front/' // 填写后台请求统一的地址
// axios.defaults.baseURL = 'http://10.16.20.196:8899/xinfuhuixuan-back/front/' // 填写后台请求统一的地址
Vue.prototype.$axios = axios

import { setRemInit } from './rem';

setRemInit(); //进行初始化立即运行
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    flag: true
  },
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js